module.exports = __webpack_public_path__ + "media/images/soar/Convidar_amigo-c60f14c9eb528ddd5106177aae2e710a.gif";